import { render, staticRenderFns } from "./VimeoVideo.vue?vue&type=template&id=6e434d08&scoped=true&"
import script from "./VimeoVideo.vue?vue&type=script&lang=js&"
export * from "./VimeoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e434d08",
  null
  
)

export default component.exports